import { render, staticRenderFns } from "./c-item-title.vue?vue&type=template&id=cbbf3c56&scoped=true"
import script from "./c-item-title.vue?vue&type=script&setup=true&lang=js"
export * from "./c-item-title.vue?vue&type=script&setup=true&lang=js"
import style0 from "./c-item-title.vue?vue&type=style&index=0&id=cbbf3c56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbf3c56",
  null
  
)

export default component.exports